import { IconChevronRight } from '../../../../design-system/components/icons/ChevronRight';
import { SkeletonRectangle } from '../../../../design-system/components/skeletons/SkeletonRectangle';

import style from './SearchLoadingState.module.css';

const SKELETON_COUNT = 4;

export function SearchLoadingState() {
    return (
        <div className={style.list}>
            {Array.from({ length: SKELETON_COUNT }, (_, index) => (
                <div key={index} className={style.skeletonItem} data-testid="search-skeleton-row">
                    <SkeletonRectangle width="56px" height="56px" />
                    <div className={style.skeletonContent}>
                        <SkeletonRectangle width="120px" height="20px" />
                        <SkeletonRectangle width="162px" height="18px" />
                    </div>
                    <IconChevronRight className={style.skeletonChevron} />
                </div>
            ))}
        </div>
    );
}
